import React from 'react';
import { DollarSignIcon, TrendingUpIcon, AwardIcon, SettingsIcon, MegaphoneIcon, UsersIcon } from 'lucide-react';
const TelecomsValue = () => {
  const commercialBenefits = [{
    title: 'New Recurring Revenue',
    description: 'Tap into non-data and prepaid segments with subscription-based AI services',
    icon: <DollarSignIcon className="h-8 w-8 text-[#54d4cb]" data-id="element-520" />
  }, {
    title: 'Enhanced Engagement',
    description: 'Increase customer stickiness through intelligent, personalized interaction',
    icon: <TrendingUpIcon className="h-8 w-8 text-[#54d4cb]" data-id="element-521" />
  }, {
    title: 'Brand Leadership',
    description: 'Position your operator as a forward-thinking AI innovator in the market',
    icon: <AwardIcon className="h-8 w-8 text-[#54d4cb]" data-id="element-522" />
  }, {
    title: 'Simple Deployment',
    description: 'Low operational overhead with minimal integration requirements',
    icon: <SettingsIcon className="h-8 w-8 text-[#54d4cb]" data-id="element-523" />
  }];
  return <>
      {/* Commercial Opportunity Section */}
      <section className="py-16 bg-white" data-id="element-524">
        <div className="container mx-auto px-4" data-id="element-525">
          <div className="max-w-5xl mx-auto" data-id="element-526">
            <div className="text-center mb-12" data-id="element-527">
              <h2 className="text-3xl font-bold mb-4" data-id="element-528">
                Commercial Opportunity
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-529">
                A new category of consumer AI product — built entirely on your
                existing assets
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-530">
              {commercialBenefits.map((benefit, index) => <div key={index} className="bg-gray-50 rounded-lg p-6 border-2 border-transparent hover:border-[#54d4cb] transition-colors" data-id="element-531">
                  <div className="flex items-start" data-id="element-532">
                    <div className="bg-[#e5f8f7] p-3 rounded-full mr-4 flex-shrink-0" data-id="element-533">
                      {benefit.icon}
                    </div>
                    <div data-id="element-534">
                      <h3 className="text-xl font-semibold mb-2" data-id="element-535">
                        {benefit.title}
                      </h3>
                      <p className="text-gray-600" data-id="element-536">{benefit.description}</p>
                    </div>
                  </div>
                </div>)}
            </div>
            <div className="bg-gradient-to-r from-[#54d4cb] to-[#3ba69f] rounded-lg p-8 text-white" data-id="element-537">
              <h3 className="text-2xl font-semibold mb-4" data-id="element-538">
                Flexible Partnership Model
              </h3>
              <p className="text-lg mb-4" data-id="element-539">
                Customize pricing, branding, and user experience to align with
                your market strategy while benefiting from a shared revenue
                structure that aligns incentives.
              </p>
              <p className="text-lg" data-id="element-540">
                Choose between full white-label deployment under your brand or
                co-branded solutions that highlight the AI capabilities.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Go-to-Market Support Section */}
      <section className="py-16 bg-gray-50" data-id="element-541">
        <div className="container mx-auto px-4" data-id="element-542">
          <div className="max-w-4xl mx-auto" data-id="element-543">
            <div className="text-center mb-12" data-id="element-544">
              <div className="inline-block p-4 bg-white rounded-full mb-4 shadow-md" data-id="element-545">
                <MegaphoneIcon className="h-12 w-12 text-[#54d4cb]" data-id="element-546" />
              </div>
              <h2 className="text-3xl font-bold mb-4" data-id="element-547">Go-to-Market Support</h2>
              <p className="text-xl text-gray-600" data-id="element-548">
                Rapid adoption through your existing customer channels
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-sm p-8 mb-8" data-id="element-549">
              <h3 className="text-2xl font-semibold mb-6 text-center" data-id="element-550">
                Launch Strategy
              </h3>
              <p className="text-lg text-gray-700 mb-6" data-id="element-551">
                The rollout leverages your existing customer communication
                channels — bulk SMS, USSD prompts, and voice announcements — to
                achieve rapid adoption with minimal marketing spend.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-552">
                <div className="bg-[#e5f8f7] rounded-lg p-6" data-id="element-553">
                  <h4 className="font-semibold text-lg mb-2 text-[#2d8a84]" data-id="element-554">
                    Full White-Label
                  </h4>
                  <p className="text-gray-700" data-id="element-555">
                    Deploy under your operator's brand for complete market
                    ownership
                  </p>
                </div>
                <div className="bg-[#e5f8f7] rounded-lg p-6" data-id="element-556">
                  <h4 className="font-semibold text-lg mb-2 text-[#2d8a84]" data-id="element-557">
                    Co-Branded
                  </h4>
                  <p className="text-gray-700" data-id="element-558">
                    "Powered by Voxie AI" to leverage established AI credibility
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-gradient-to-br from-[#54d4cb] to-[#3ba69f] rounded-lg p-8 text-white text-center" data-id="element-559">
              <div className="inline-block p-4 bg-white/20 rounded-full mb-4" data-id="element-560">
                <UsersIcon className="h-12 w-12 text-white" data-id="element-561" />
              </div>
              <h3 className="text-2xl font-semibold mb-4" data-id="element-562">Core Message</h3>
              <p className="text-xl font-medium" data-id="element-563">
                "Generative AI, now available for everyone — no data required."
              </p>
            </div>
            <div className="text-center mt-12" data-id="element-564">
              <a href="https://calendly.com/es-lee/intro?referrer=voxiesite" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#54d4cb] text-white px-8 py-4 rounded-md font-semibold text-lg hover:bg-[#43aca5] transition-colors shadow-lg" data-id="element-565">
                Schedule a Partnership Discussion
              </a>
            </div>
          </div>
        </div>
      </section>
    </>;
};
export default TelecomsValue;